import { configureStore, ThunkAction, Store, Action } from '@reduxjs/toolkit'
import rootReducer from './rootReducer';
import api from '../api';

const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware),
})

export type AppThunk = ThunkAction<void, Store, unknown, Action<string>>;

export default store